import React from "react";
import "./LpExp.css";

const LpExpHead = () => {
  return (
    <div className="lpExpHead-container" id="why">
      <div className="lpExpHead-content">
        <h5>Experience</h5>
      </div>
      <h2>
        Trusted Attestation <span>Experience</span>
      </h2>
    </div>
  );
};

export default LpExpHead;
